import jwtDecode from 'jwt-decode';
import { User } from '../types/user';

export function getJwt() {
  return jwtDecode<Pick<User, 'id' | 'name' | 'email'>>(
    sessionStorage.getItem('token'),
  );
}
